import React from 'react';
import './HintCounter.css';

const HintCounter = ({ currentIndex, total }) => {
  return (
    <span className="hint-counter">
      Clue : {currentIndex} / {total}
    </span>
  );
};

export default HintCounter; 